<template>
    <div>
        <el-dialog :visible.sync="newDialog"  center :close-on-click-modal="true" @close="closeDialog"
            custom-class="dialog_normalsuo dialog_normalsuo_update"  :append-to-body="true">
            <div>
                <div class="detail_cont">
                    <div class="flex_center margin-bottom20"><img style="width: 5.7142857rem;height: 5rem;" src="../../assets/dialogIcoImg/updateIcon.png" alt=""></div>
                    <h3>{{ $t('ListofResults.Update') }}</h3>
                    <div class="detail_cont_text" style="padding: 0px;">
                       Upon placing your order for comprehensive reports, your order will initiate offline research and investigation. Each company will be charged {{ HuokeDetailPoint }} credits for this order. Your reports will typically be delivered to your account within 72 hours. Please check your email notification for the details.
                        </div>

                </div>
            </div>
            <div class="flex_center" style="margin-top: 20px;">
                <el-button class="btn_export btn_exportCCC" @click="onSubmitkoudian()">{{ $t('ListofResults.Update') }}</el-button>
                <el-button v-if=" $store.state.app.equityType<HuokeDetailPoint" class="btn_export" @click="onSubmitquxiao()">{{ $t('navigationBar.AddCredits') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { saveUserConsumptionBatch, getPointAndHour} from "@/api/userApi";
import {  getUserSimpleInfo } from "@/api/companyApi.js";
export default {
    props: {
        suoClose: {
            type: Boolean,
            //   default: false,
        },
        obj: {
            type: Object,
        },
        update: {
            type: Object,
        },
        ComapnyName:{
            type:String
        }
    },
    data() {
        return {
            HuokeDetailPoint:0,            //page: this.currentPage

            token: sessionStorage.getItem('token'),
        };
    },
    computed: {
        newDialog: {
            get() {
             if(this.suoClose){
                      this.getgetPointAndHour()
             }
                return this.suoClose;
            },
            set() { },
        },

    },
    destroyed() {
        // bus.$off('handleShowLogin');
    },
    mounted() {
       
    },
    methods: {
        getgetPointAndHour(){
                let UpdatePoint = []
                  this.$store.state.app.changeList.map((item) => {
                UpdatePoint.push({
                    countryCode: item.countryCode,
                    companyName: item.companyNameEn,
                    companyAaaid: item.aaaId

                });
            });
            getPointAndHour(UpdatePoint).then(res=>{
                if(res.code==200){
                    this.HuokeDetailPoint=res.data.point
                    
                }
            })
        },
        //关闭弹窗
        closeDialog() {
            this.$emit('closeCloseDialog', false);
        },
        onSubmitkoudian() {
            this.newDialog = false;
            this.$emit('closeCloseDialog', false);
            const base = JSON.parse(localStorage.getItem("CompanyBase"));
              let Updatelis = []

            this.$store.state.app.changeList.map((item) => {
                Updatelis.push({
                     countryCode: item.countryCode,
                    companyName: item.companyNameEn,
                    companyAaaid: item.aaaId

                });
            });
      saveUserConsumptionBatch(Updatelis).then(res => {
                if (res.code == 200) {
                      this.$message({
                        message: res.msg,
                        type: 'success'
                    })
                       getUserSimpleInfo().then(res => {
                        if (res.code == 200) {
                            this.$store.dispatch("app/setEquityType", res.data.availablePoints);
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
            //  this.$emit('closeCloseDialog1', true);


        },
        onSubmitquxiao() {
      this.$router.push({
        path: '/index/addCredit',
      });
            // this.newDialog = false;
            // this.$emit('closeCloseDialog', false);
            let that = this;
            let userinfo = JSON.parse(localStorage.getItem('userInfo')).userInfo;


        },
    },
};
</script>
<style scoped>
.detail_cont {
    max-height: 68%;
    overflow: auto;

}



</style>
